import { render } from "./Electro3Footer.vue?vue&type=template&id=14e4fba9&scoped=true"
const script = {}

import "./Electro3Footer.vue?vue&type=style&index=0&id=14e4fba9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e4fba9"]])

export default __exports__